import { $isListItemNode, $isListNode } from "@lexical/list";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey, $isTextNode, TextNode } from "lexical";
import { toPairs } from "lodash-es";
import { useEffect } from "react";

export function BulletIndentStylePlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerMutationListener(
        TextNode,
        (mutatedNodes, { updateTags }) => {
          toPairs(mutatedNodes).map(([key, mutation]) => {
            if (mutation !== "created" || updateTags.has("bullet-nested-indent-style")) return;

            editor.update(
              () => {
                const node = $getNodeByKey(key);

                if (!node) return;
                if (!$isTextNode(node)) return;

                const parent = node.getParent();

                // If the parent is not a list item, (i.e it's a paragraph or something else) we don't need to do anything
                if (!$isListItemNode(parent)) return;

                // If the parent is not the first item in the list we don't need to do anything
                if (parent.getIndexWithinParent() !== 0) return;

                const grandParent = parent.getParent();

                // If the grandParent is not a list node, we are in a weird state, so should return
                if (!$isListNode(grandParent)) return;

                const greatGrandParent = grandParent.getParent();

                // If the great grand parent is not a list item, then we aren't in an indented list, so we should return
                if (!$isListItemNode(greatGrandParent)) return;

                // If the parent is not indented one level more than the great grand parent, we should return
                if (parent.getIndent() !== greatGrandParent.getIndent() + 1) return;

                const sibling = greatGrandParent.getPreviousSibling();
                if (!$isListItemNode(sibling)) return;

                // We look for the last child of the sibling, if it's not a text node, we should return
                const greatGrandParentSiblingLastChild = sibling.getLastChild();

                if (!$isTextNode(greatGrandParentSiblingLastChild)) return;

                const newStyle = greatGrandParentSiblingLastChild.getStyle();

                if (!newStyle) return;

                node.setStyle(newStyle);
              },
              { tag: "bullet-nested-indent-style" },
            );
          });
        },
        { skipInitialization: true },
      ),
    [editor],
  );

  return null;
}
